import * as React from "react";
import { SurveyPublishStatus } from "@graffer-inc/cloud-gov-core";

export type SurveyStatusTagProps = {
  surveyStatus: SurveyPublishStatus;
  size?: "is-normal" | "is-medium";
};

export const SurveyStatusTag: React.FC<SurveyStatusTagProps> = ({
  surveyStatus,
  size = "is-medium",
}) => {
  const baseClass = `tag ${size}`;

  switch (surveyStatus) {
    case "DRAFT":
      return <span className={`${baseClass} is-light`}>下書き</span>;
    case "BEFORE_PUBLISH":
      return <span className={`${baseClass} is-dark`}>公開前</span>;
    case "BEFORE_ACCEPTING":
      return <span className={`${baseClass} is-dark`}>受付前</span>;
    case "ACCEPTING":
      return <span className={`${baseClass} is-primary`}>受付中</span>;
    case "PAUSING_ACCEPT":
      return <span className={`${baseClass} is-warning`}>受付停止中</span>;
    case "FINISHED_ACCEPTING":
      return (
        <span className={`${baseClass} is-outlined is-black`}>受付終了</span>
      );
    case "UNPUBLISHED":
      return (
        <span className={`${baseClass} is-outlined is-black`}>公開終了</span>
      );
    default:
      return <span />;
  }
};
